import React from "react";
import { Modal } from "antd";

const LocationModal = ({
  open,
  onClose,
  latitude,
  longitude,
  title = "Location",
}) => {
  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      destroyOnClose
    >
      {latitude && longitude && (
        <iframe
          title="Location Map"
          width="100%"
          height="500"
          style={{ border: 0 }}
          loading="lazy"
          src={`https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
        />
      )}
    </Modal>
  );
};

export default LocationModal;